import { GridWidgetService } from "../grid-widget.services";
import { SystemService } from "common/services/core-services/system.service";
import {
  MetaModel,
  WidgetModel,
} from "common/models/utility-models/base-model";
import { Injectable } from "@angular/core";
import { DashboardModel } from "common/models/page-models/dashboard/dashboard-data-model";
import { DashboardListingModel } from "common/models/page-models/dashboard/dashboard-grid-model";
import { DashboardGridMetaModel } from "common/models/page-models/dashboard/dashboard-meta-model";
import { GridParams } from "common/models/utility-models/list-utility.model";
import { DashboardGridPostParams } from "common/models/page-models/dashboard/dashboard-grid-params";
import { DashboardDataService } from "common/services/data-services/dashboard/dashboard-data.service";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class DashboardWidgetService extends GridWidgetService<
  DashboardModel,
  DashboardListingModel
> {
  constructor(
    protected override ds: DashboardDataService,
    protected systemService: SystemService
  ) {
    super(ds);
  }

  getMetaModel(): MetaModel {
    const meta = new DashboardGridMetaModel().getMetaModel();
    return meta;
  }

  override prepareMetaModel(
    dataModel: DashboardListingModel,
    metaModel: DashboardGridMetaModel,
    routeData: WidgetModel
  ): Promise<DashboardGridMetaModel> {
    return new Promise<DashboardGridMetaModel>((resolve, reject) => {
      resolve(metaModel);
    });
  }

  async generateDashboardData(params: any, apiUrl: any): Promise<any> {
    return await new Promise<any>((resolve, reject) => {
      const payload = new DashboardGridPostParams();
      // console.log(params, payload, "generateDashboardData");
      payload.fromDate_search =
        params.selectedFromDate === "" || params.selectedFromDate === null
          ? params.selectedFromDate
          : this.formatDate(params.selectedFromDate);

      payload.toDate_search =
        params.selectedToDate === "" || params.selectedToDate === null
          ? params.selectedToDate
          : this.formatDate(params.selectedToDate);

      this.ds
        .postDataToCustomEndPoint(payload, null, environment.apiUrl + apiUrl)
        .then((result:any) => {
          this.ds
            .createGridModel(
              result,
              new GridParams(),
              this.ds.getDataParam(),
              this.ds.getExtraParam()
            )
            .then((gridData) => {
              resolve(gridData);
            })
            .catch((e) => {
              reject(e);
            });
          this.systemService.showSuccess(result.msg);
        });
    });
  }

  formatDate(originalDateString) {
    const date = new Date(originalDateString);
    // console.log(date, "formatDate");
    // Format the date as "YYYY-MM-DD HH:MM:SS"
    const formattedDate =
      date.getFullYear() +
      "-" +
      String(date.getMonth() + 1).padStart(2, "0") +
      "-" +
      String(date.getDate()).padStart(2, "0") +
      " " +
      String(date.getHours()).padStart(2, "0") +
      ":" +
      String(date.getMinutes()).padStart(2, "0") +
      ":" +
      String(date.getSeconds()).padStart(2, "0");

    // console.log(formattedDate);
    return formattedDate;
  }
}
